import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
function YoutubeSlider() {
  const settingss = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    centerMode: true, // Add this property
    centerPadding: "0", // Optional: Adjust padding if needed
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          autoplay: true,
          autoplaySpeed: 3000,
          centerMode: true,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
          autoplay: true,
          autoplaySpeed: 3000,
          centerMode: true,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          centerMode: true,
          centerPadding: "0",
        },
      },
    ],
  };
  return (
    <section className="p70   pb-md-5 video_section text-center mt-5">
      <div className="container  position-relative">
        <h2 className="hadding text-center mb-2">
          Youtubers Talking <span className="color1">About Scotty </span>
        </h2>
        <h5 className="text-center mb-4">Over 500,000 views on YouTube </h5>
        <div className="row">
          <div className="col-md-12 m-auto">
            <Slider {...settingss}>
              <div>
                <a
                  href="https://www.youtube.com/watch?v=xg8y5vvKyFc"
                  target="_blank"
                >
                  <img
                    src="/assets/img/video1.jpg"
                    alt="scotty Youtub4"
                    className="w100"
                  />
                </a>
              </div>
              <div>
                <a
                  href="https://www.youtube.com/watch?v=1EXiOg4lcsk"
                  target="_blank"
                >
                  <img
                    src="/assets/img/video2.jpg"
                    alt="scotty Youtub"
                    className="w100"
                  />
                </a>
              </div>
              <div>
                <a
                  href="https://www.youtube.com/watch?v=l2YOMpF3k6o"
                  target="_blank"
                >
                  <img
                    src="/assets/img/video3.jpg"
                    alt="scotty Youtub2"
                    className="w100"
                  />
                </a>
              </div>
              <div>
                <a
                  href="https://www.youtube.com/watch?v=hdSkSKN9SQo"
                  target="_blank"
                >
                  <img
                    src="/assets/img/video4.jpg"
                    alt="scotty Youtub4"
                    className="w100"
                  />
                </a>
              </div>
              <div>
                <a
                  href="https://www.youtube.com/watch?v=wgi5J0IyHg0"
                  target="_blank"
                >
                  <img
                    src="/assets/img/video5.jpg"
                    alt="scotty Youtub"
                    className="w100"
                  />
                </a>
              </div>
              <div>
                <a
                  href="https://www.youtube.com/watch?v=XcMqK_dSgzY"
                  target="_blank"
                >
                  <img
                    src="/assets/img/video6.jpg"
                    alt="scotty Youtub2"
                    className="w100"
                  />
                </a>
              </div>
              <div>
                <a
                  href="https://www.youtube.com/watch?v=8nShe2WOiNg"
                  target="_blank"
                >
                  <img
                    src="/assets/img/video7.jpg"
                    alt="scotty Youtub2"
                    className="w100"
                  />
                </a>
              </div>
              <div>
                <a
                  href="https://www.youtube.com/watch?v=2GVTcT8-kEY"
                  target="_blank"
                >
                  <img
                    src="/assets/img/video8.jpg"
                    alt="scotty Youtub2"
                    className="w100"
                  />
                </a>
              </div>
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
}

export default YoutubeSlider;
